export const W9_MODALS_LOADING_STATES = {
    REQUEST_BULK_W9_LOADING: "REQUEST_BULK_W8_LOADING",
    REQUEST_BULK_W9_READY: "REQUEST_BULK_W8_READY",
    DISPLAY_PLANS_VIEW_LOADING: "DISPLAY_PLANS_VIEW_LOADING",
    DISPLAY_PLANS_VIEW_READY: "DISPLAY_PLANS_VIEW_READY",
    GET_W9_REQUEST_COUNT_LOADING: "GET_W9_REQUEST_COUNT_LOADING",
    GET_W9_REQUEST_COUNT_READY: "GET_W9_REQUEST_COUNT_READY",
    GET_W9_FEES_LOADING: "GET_W9_FEES_LOADING",
    GET_W9_FEES_READY: "GET_W9_FEES_READY",
}

export const W9_MODALS_MESSAGE_MAP = {}